export default __webpack_public_path__ + "static/media/cheacker.7c392295.png";